import { render, staticRenderFns } from "./GridItemAdd.vue?vue&type=template&id=697cc520&scoped=true"
import script from "./GridItemAdd.vue?vue&type=script&lang=js"
export * from "./GridItemAdd.vue?vue&type=script&lang=js"
import style0 from "./GridItemAdd.vue?vue&type=style&index=0&id=697cc520&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697cc520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697cc520')) {
      api.createRecord('697cc520', component.options)
    } else {
      api.reload('697cc520', component.options)
    }
    module.hot.accept("./GridItemAdd.vue?vue&type=template&id=697cc520&scoped=true", function () {
      api.rerender('697cc520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/browser/GridItemAdd.vue"
export default component.exports